import { useEffect } from 'react';

export const useAutoRange = (
  data: any[],
  availableRanges: any[],
  selectedRange: any,
  setSelectedRange: (range: any) => void
) => {
  useEffect(() => {
    if (data.length === 0 && availableRanges.length > 0) {
      const firstAvailableRange = availableRanges[0];
      if (selectedRange !== firstAvailableRange) {
        setSelectedRange(firstAvailableRange);
      }
    }
  }, [data, availableRanges, selectedRange, setSelectedRange]);
};
